import {createTheme} from '@material-ui/core/styles';

const theme = createTheme({});

export default theme;
